import React from 'react'
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table'
import { translateProfileFields, PriceWithWords } from '../../../helpers/utility'
import { toPersianDigit } from '../../../helpers/nums'
import moment from 'moment-jalaali'

const styles = {
  table: {
    width: '100%',
    fontFamily: 'IranYekanRegular'
  },
  tableRowColumn: {
    textAlign: 'right',
    whiteSpace: 'pre-wrap'
  }
}

const OrderTable = ({
  data: { amount, order_status, created_at, update_at, service: { title } }
}) => (
  <Table style={styles.table}>
    <TableBody displayRowCheckbox={false}>
      <TableRow hoverable={true} key={0}>
        <TableRowColumn style={styles.tableRowColumn}>
          سرویس خریداری شده
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowColumn}>{title}</TableRowColumn>
      </TableRow>‌
      <TableRow hoverable={true} key={2}>
        <TableRowColumn style={styles.tableRowColumn}>مبلغ سفارش</TableRowColumn>
        <TableRowColumn style={styles.tableRowColumn}>
          <PriceWithWords>{amount}</PriceWithWords>
        </TableRowColumn>
      </TableRow>
      <TableRow hoverable={true} key={1}>
        <TableRowColumn style={styles.tableRowColumn}>وضعیت سفارش</TableRowColumn>
        <TableRowColumn style={styles.tableRowColumn}>
          {translateProfileFields(order_status)}
        </TableRowColumn>
      </TableRow>
      <TableRow hoverable={true} key={3}>
        <TableRowColumn style={styles.tableRowColumn}>تاریخ سفارش</TableRowColumn>
        <TableRowColumn style={styles.tableRowColumn}>
          {toPersianDigit(moment(created_at).format('jYYYY/jM/jD-HH:MM'))}
        </TableRowColumn>
      </TableRow>
      <TableRow hoverable={true} key={4}>
        <TableRowColumn style={styles.tableRowColumn}>
          اخرین تغییر وضعیت
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowColumn}>
          {toPersianDigit(moment(update_at).format('jYYYY/jM/jD-HH:MM'))}
        </TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>
)

export default OrderTable



// WEBPACK FOOTER //
// ./src/components/common/orders/OrderTable.js